import script from "./QrcodeTwikey.vue?vue&type=script&setup=true&lang=js"
export * from "./QrcodeTwikey.vue?vue&type=script&setup=true&lang=js"

import "./QrcodeTwikey.vue?vue&type=style&index=0&id=2bc53465&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc53465"]])

export default __exports__